import * as React from 'react';
import { TextButton, Modal, Container, Textarea } from '../../../Components';
import styled from 'styled-components';
import { ValidationError } from '../../../Store';

interface IModalProps {
  isOpen: boolean;
  outterClick: (() => void);
  onTextChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  texto: string;
  reprovar: () => void;
  errors: ValidationError<{ justificativa: string }>;
}

const StyledModal = styled(Modal)`
    font-family: Roboto,sans-seriff;
    height: fit-content;
    min-height: 200px;
`;

const ContainerGrid = styled(Container)`
  grid-template-columns: repeat(12, 1fr);
  padding-left: 30px;
`;

const StyledTitle = styled.span`
    font-size: 20px;
    padding: 10px 0px 0px 0px;
    font-weight: 500;
    grid-column: 1/13;
`;

const StyledSubTitle = styled.span`
    color: gray;
    font-size: 13px;
    padding: 5px 5px 20px 0px;
    grid-column: 1/13;
`;
const TextareaGrid = styled(Textarea)`
    background-color: transparent;
    margin: 0;
    margin-right: 15px;
    grid-column: 1/13;
`;

const StyledTextButton = styled(TextButton)`
    grid-column: 1/13;
    justify-self: flex-end;
`;

const JustificativaDaReprovacaoModal: React.FC<IModalProps> = (props: IModalProps) => {
  const { isOpen, outterClick, texto, onTextChange, reprovar, errors } = props;

  return (
    <StyledModal
      size='medium'
      outterClick={outterClick}
      isVisible={isOpen}
    >
      <ContainerGrid>
        <StyledTitle>Rejeitar Depósito </StyledTitle>
        <StyledSubTitle>Informe o motivo da rejeição, indicando as correções substanciais a serem feitas.</StyledSubTitle>
        <TextareaGrid
          label='Justificativa'
          name='justificativa'
          value={texto}
          onChange={onTextChange}
          color={
            errors && errors.justificativa != undefined ? 'errorColor'
              : 'secondaryLightColor'}
          gridColumn='1/13'
          hasError={errors && errors.justificativa != undefined}
          errorMessage={errors && errors.justificativa}
        />
        <StyledTextButton
          type='submit'
          color='secondaryLightColor'
          onClick={reprovar}
        >
          CONFIRMAR
        </StyledTextButton>
      </ContainerGrid>
    </StyledModal>
  );
};

export default JustificativaDaReprovacaoModal;
